import React, { useEffect, useState } from 'react'
import {useDispatch,useSelector} from "react-redux"
import { getStates,getCountries,getCities, clearStates, clearCities } from '../../actions/locationActions';

import { useTokenCallback } from './useTokenCallback';

export const usePlaces = (countryValue,stateValue) => {
    const {countries,states,cities} = useSelector(state => state.locations)
    const dispatch = useDispatch()
    
    useTokenCallback(()=>{
        dispatch(getCountries())
    },[])
    useTokenCallback(() => {        
        const country = countries.find ((country)=> country.countryName===countryValue)        
        if(country){
            dispatch(getStates(country.countryID))
        }else{
            dispatch(clearStates())
            dispatch(clearCities())
        }
    }, [countries,countryValue])
    useTokenCallback(() => {        
        
        const state = states.find ((state)=> state.stateName===stateValue)
        console.log();
        if(state){
            dispatch(getCities(state.stateID))
        }else{
            dispatch(clearCities())
        }
    }, [states,stateValue])
 return {countries,states,cities}
    
}
